module.exports = __webpack_public_path__ + "static/media/LK__Savings.08e1bc6a.svg";